import Swiper from "swiper";

import BasePage from "@Scripts/Pages/BasePage";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();

        this.setVisuals();
    }

    private static setVisuals() {
        window.addEventListener("load", function () {
            new Swiper(".swiper-container", {
                effect: "fade",
                loop: true,
                preloadImages: false,
                lazy: {
                    loadOnTransitionStart: true,
                    loadPrevNext: false
                },
                autoplay: {
                    delay: 8000,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        });
    }
}